import zxcvbn from 'zxcvbn';

const getPasswordStrengthPlusOne = (password: string): number =>
  zxcvbn(password).score + 1;

export default getPasswordStrengthPlusOne;
